// extracted by mini-css-extract-plugin
export default {"Container":"insights-layout-module__Container__uJC93eL","Pane":"insights-layout-module__Pane__yUsp4CG","MainContent":"insights-layout-module__MainContent__rUD5Ekz"};